import React from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './theme/index.scss';
import { App } from './App';
import './bootstrap/register-shift-worker';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Missing root element');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <MantineProvider>
      <Notifications position="top-left" />
      <App />
    </MantineProvider>
  </React.StrictMode>,
);
